import React from "react";
import { useResponsiveBelowMd } from "src/hooks";
import { ActionSection } from "./ActionSection";
import { ActionSectionBelowMd } from "./ActionSection.belowMd";

export default function ActionSectionResponsive() {
  const isBelowMd = useResponsiveBelowMd();
  return isBelowMd ? <ActionSectionBelowMd /> : <ActionSection />;
}
